import { render, staticRenderFns } from "./CampaignConfirmation.vue?vue&type=template&id=59f2343a&scoped=true"
import script from "./CampaignConfirmation.vue?vue&type=script&lang=js"
export * from "./CampaignConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f2343a",
  null
  
)

export default component.exports